import { CurrentUserType } from 'redux/reducers/UserReducer/types'

export const hasUserReadOnlyAccess = (data?: CurrentUserType): boolean => {
  if (data?.writeAccess) {
    return !data.writeAccess
  }

  return true
}
